import React from 'react';
import NotFoundComp from '../components/NotFoundComp/NotFoundComp';

const NotFound = () => {
    return (
        <div className="h-screen">
            {/* Not found component added */}
            <NotFoundComp></NotFoundComp>
        </div>
    );
};

export default NotFound;